import React from "react";
import Hero from "./Hero";

const ProjectHero = ({ heroData, API_BASE_URL }) => {
  // ✅ Add debugging
  console.log("ProjectHero - heroData:", heroData);
  
  const imageUrl = heroData?.image || "";
  console.log("ProjectHero - imageUrl:", imageUrl);

  const slides = [
    {
      images: [imageUrl],
      title: heroData?.title || "",
      subtitle:
        heroData?.subtitle ||
        "",
    },
  ];

  console.log("ProjectHero - slides:", slides);

  return (
    <div className="w-full overflow-hidden">
      <Hero
        slides={slides}
        intervalMs={6000}
      />
    </div>
  );
};

export default ProjectHero;